import React from "react";
import { MapPin, Star } from "lucide-react";

export default function ExploreDoctorCard({
  doctor,
  onOpenProfile,
  onBook,
}) {
  const {
    avatarUrl,
    initials,
    name,
    specialty,
    locationLabel,   // "Tiranë, 1.2 km larg"
    rating,          // number, e.g. 4.8
    ratingCount,     // e.g. 23
    priceLabel,      // "Konsulta nga 3,000 LEK"
    badges = [],     // ["Top rated", "Për fëmijë", etc]
  } = doctor;

  return (
    <div className="p2-explore-doctor-card">
      {/* Avatar */}
      <button
        type="button"
        onClick={() => onOpenProfile?.(doctor)}
        className="p2-explore-avatar-btn"
      >
        {avatarUrl ? (
          <img
            src={avatarUrl}
            alt={name || "Doctor"}
            className="p2-explore-avatar-img"
          />
        ) : (
          <span>
            {initials || (name ? name[0] : "D")}
          </span>
        )}
      </button>

      {/* Main info */}
      <div className="p2-explore-main">
        <button
          type="button"
          onClick={() => onOpenProfile?.(doctor)}
          className="p2-explore-name-block"
        >
          <p className="p2-explore-name">
            {name || "Mjek pa emër"}
          </p>
          <p className="p2-explore-specialty">
            {specialty || "Specialitet i pa specifikuar"}
          </p>
        </button>

        {locationLabel && (
          <p className="p2-explore-location-row">
            <MapPin className="p2-explore-location-icon" />
            <span className="p2-explore-location-text">
              {locationLabel}
            </span>
          </p>
        )}

        {/* Badges / tags */}
        {badges.length > 0 && (
          <div className="p2-explore-badges">
            {badges.map((b) => (
              <span
                key={b}
                className="p2-pill p2-pill-sky p2-explore-badge"
              >
                {b}
              </span>
            ))}
          </div>
        )}

        {/* Bottom: rating + price + actions */}
        <div className="p2-explore-bottom">
          <div className="p2-explore-rating-block">
            {typeof rating === "number" && (
              <div className="p2-explore-rating-row">
                <span className="p2-explore-rating-icon">
                  <Star className="p2-explore-rating-icon-inner" />
                </span>
                <span className="p2-explore-rating-value">
                  {rating.toFixed(1)} ★
                </span>
                {ratingCount ? (
                  <span className="p2-explore-rating-count">
                    ({ratingCount})
                  </span>
                ) : null}
              </div>
            )}

            {priceLabel && (
              <p className="p2-explore-price">
                {priceLabel}
              </p>
            )}
          </div>

          <div className="p2-explore-actions">
            <button
              type="button"
              onClick={() => onBook?.(doctor)}
              className="p2-explore-book-btn"
            >
              Rezervo vizitë
            </button>
            <button
              type="button"
              onClick={() => onOpenProfile?.(doctor)}
              className="p2-explore-profile-btn"
            >
              Shiko profilin
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
